import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69f32dc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "password_reset_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "password_reset_title" }, "パスワード再設定", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "password_reset_form" }
const _hoisted_5 = { class: "password_reset_label" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "password_reset_description" }, " パスワードは半角英数字6文字以上12文字以内のアルファベットと数字を各1文字以上を使用してください ", -1))
const _hoisted_7 = { class: "password_reset_form" }
const _hoisted_8 = { class: "password_reset_label" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"password_reset_invalid\" data-v-69f32dc4><p class=\"password_reset_invalid_text\" data-v-69f32dc4>このURLは有効期限が切れたか、無効なURLです。</p><p class=\"password_reset_invalid_description\" data-v-69f32dc4><span class=\"password_reset_invalid_description_clause\" data-v-69f32dc4>再度、パスワード再設定をしたい場合は</span><span class=\"password_reset_invalid_description_clause\" data-v-69f32dc4>ログイン画面の「パスワードをお忘れの方」から</span><span class=\"password_reset_invalid_description_clause\" data-v-69f32dc4>もう一度、お試しください。</span></p></div>", 1)

import BaseButton from '@/components/BaseButton.vue';
import BasePasswordForm from '@/components/BasePasswordForm.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import Loading from '@/components/Loading.vue';
import { useRoute, useRouter } from 'vue-router';
import { useField, useForm } from 'vee-validate';
import { validationRuleHelper } from '@/utils/validationRule';
import { putPasswordSetting, postPasswordCheckKey } from '@/api/accountEndpoint';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordReset',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const isLoading = ref(false);
const uniqueKey = route.params.uniqueKey as string;

const { meta, errors } = useForm();

const {
  value: password,
  errors: passwordErrors,
  meta: passwordMeta,
} = useField<string>('password', validationRuleHelper({ required: true, min: 6, max: 12, password: true }), {
  bails: false,
  label: '新しいパスワード',
});
const { value: passwordConfirm, errors: passwordConfirmErrors } = useField<string>(
  'passwordConfirm',
  validationRuleHelper({ required: true, confirmation: '@password' }),
  {
    bails: false,
    label: '新しいパスワード（再入力）',
  }
);

const forwardToLogin = () => {
  router.push({ name: 'a10' });
};

const isValdUniqueKey = ref(true);
const send = async () => {
  isLoading.value = true;
  try {
    const res = await putPasswordSetting({
      uniqueKey: uniqueKey,
      password: password.value,
    });
    isValdUniqueKey.value = res.checkResult;
    if (isValdUniqueKey.value) {
      router.push({ name: 'a23' });
    }
  } finally {
    isLoading.value = false;
  }
};
const init = async () => {
  isLoading.value = true;
  try {
    const resCheckKey = await postPasswordCheckKey(uniqueKey);
    isValdUniqueKey.value = resCheckKey.checkResult;
  } finally {
    isLoading.value = false;
  }
};
init();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (isValdUniqueKey.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", _hoisted_5, [
                _createTextVNode(" 新しいパスワード "),
                _createVNode(BasePasswordForm, {
                  placeholder: "パスワード",
                  isError: _unref(passwordMeta).touched && !!_unref(errors).password,
                  modelValue: _unref(password),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(password) ? (password).value = $event : null)),
                  onFocusout: _cache[1] || (_cache[1] = () => (_unref(passwordMeta).touched = true))
                }, null, 8, ["isError", "modelValue"])
              ]),
              (_unref(passwordMeta).touched && _unref(errors).password)
                ? (_openBlock(), _createBlock(ErrorMessage, {
                    key: 0,
                    errors: _unref(passwordErrors)
                  }, null, 8, ["errors"]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, [
                _createTextVNode(" 新しいパスワード（再入力） "),
                _createVNode(BasePasswordForm, {
                  placeholder: "パスワード",
                  modelValue: _unref(passwordConfirm),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(passwordConfirm) ? (passwordConfirm).value = $event : null)),
                  isError: !!_unref(errors).passwordConfirm
                }, null, 8, ["modelValue", "isError"])
              ]),
              (_unref(errors).passwordConfirm)
                ? (_openBlock(), _createBlock(ErrorMessage, {
                    key: 0,
                    errors: _unref(passwordConfirmErrors)
                  }, null, 8, ["errors"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(BaseButton, {
              class: "password_reset_button",
              disabled: !_unref(meta).valid,
              onClick: send
            }, {
              default: _withCtx(() => [
                _createTextVNode("送信")
              ]),
              _: 1
            }, 8, ["disabled"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(BaseButton, {
              class: "password_reset_button",
              onClick: forwardToLogin
            }, {
              default: _withCtx(() => [
                _createTextVNode("ログインへ")
              ]),
              _: 1
            })
          ]))
    ])
  ]))
}
}

})